/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DataModelRangeAnalysisPoint } from './DataModelRangeAnalysisPoint';

export type DataModelRangeAnalysisDistributionBucket = {
    type: DataModelRangeAnalysisDistributionBucket.type;
    index: number | null;
    low: number | null;
    high: number | null;
    employees: Array<DataModelRangeAnalysisPoint>;
};

export namespace DataModelRangeAnalysisDistributionBucket {

    export enum type {
        BELOW = 'below',
        WITHIN = 'within',
        ABOVE = 'above',
    }


}

